export const MOBILE_VIEW_TRESHOLD = 768;
export const MOBILE_NAVIGATION = 1000;
// EU Countries - https://ec.europa.eu/eurostat/statistics-explained/index.php/Glossary:Country_codes
export const EUROPE_COUNTRIES = [
  'de',
  'be',
  'lt',
  'pt',
  'bg',
  'es',
  'lu',
  'ro',
  'cz',
  'fr',
  'hu',
  'si',
  'dk',
  'hr',
  'mt',
  'sk',
  'de',
  'it',
  'nl',
  'fi',
  'ee',
  'cy',
  'at',
  'se',
  'ie',
  'lv',
  'pl',
  'gb',
  'mc',
  'ad',
  'ch',
  'fo',
  'gi',
  'ru',
  'rs',
  'tr',
  'ua',
  'am',
  'by',
  'ba',
  'ge',
  'mk',
  'md',
  'al',
  'me',
  'gr',
  'is',
  'li',
  'no'
];
export const EXAMPLE_PHONE_NUMBER_CH = '78 123 45 67';

export interface RiskConstant {
  SHORT_INVESTMENT: {
    optionInyovaID: number;
    questionInyovaID: number;
  };
  AGE_QUESTION: number;
  SLIDER_QUESTION: number;
  BASIC_QUESTIONS: number[];
  DEFAULT_QUESTIONS: number[];
  FAMILIAR_QUESTION: number;
  FAMILIAR_QUESTIONS: number[];
  FAMILIAR_QUESTION_OPTION_ID_TOOLTIP: number[];
  FAMILIAR_COMBINATION: {
    optionInyovaID: number;
    questionInyovaID: number;
  }[];
  KNOWLEDGE_QUESTIONS_FIRST: number[];
  KNOWLEDGE_QUESTION_9: number;
  KNOWLEDGE_QUESTION_10: number;
  ALL_KNOWLEDGE_QUESTIONS: number[];
  QUESTION_10_LAST_OPTION_INYOVA_ID: number;
  QUESTION_11_LAST_OPTION_INYOVA_ID: number;
  INVESTMENT_HORIZON_FIRST_QUESTION_ID: number;
  INVESTMENT_HORIZON_SECOND_QUESTION_ID: number;
}

export interface Bond {
  id: string;
  img: string;
  perc: number;
}

// Cross products dependencies (3a, CH, DE), keep in mind when changing
export const RISK_CONSTANTS: RiskConstant = {
  SHORT_INVESTMENT: { optionInyovaID: 1, questionInyovaID: 1 },
  SLIDER_QUESTION: 5,
  AGE_QUESTION: 2,
  BASIC_QUESTIONS: [1, 2, 3, 4],
  DEFAULT_QUESTIONS: [1, 2, 3, 4, 7],
  FAMILIAR_QUESTION: 7,
  FAMILIAR_QUESTIONS: [8, 9, 10],
  FAMILIAR_QUESTION_OPTION_ID_TOOLTIP: [41, 42, 43],
  FAMILIAR_COMBINATION: [
    { optionInyovaID: 28, questionInyovaID: 8 },
    { optionInyovaID: 29, questionInyovaID: 9 },
    { optionInyovaID: 30, questionInyovaID: 10 },
    { optionInyovaID: 31, questionInyovaID: 11 }
  ],
  KNOWLEDGE_QUESTIONS_FIRST: [8, 9, 10],
  KNOWLEDGE_QUESTION_9: 11,
  KNOWLEDGE_QUESTION_10: 12,
  ALL_KNOWLEDGE_QUESTIONS: [8, 9, 10, 11, 12],
  QUESTION_10_LAST_OPTION_INYOVA_ID: 75,
  QUESTION_11_LAST_OPTION_INYOVA_ID: 78,
  INVESTMENT_HORIZON_FIRST_QUESTION_ID: 2,
  INVESTMENT_HORIZON_SECOND_QUESTION_ID: 1
};

export const AOCH_EMPLOYMENT_INYOVA_IDS = {
  STUDENT: 32,
  RETIRED: 31,
  UNEMPLOYED: 93,
  EMPLOYED_PRIVATE_COMPANY: 34,
  PRIVATE_COMPANY: 94,
  SELF_EMPLOYMENT: 30,
  NOT_ABOVE: 112
};

export const AOCH_SOURCE_OF_FUNDS_INYOVA_IDS = {
  SALARY: 113,
  INHERITANCE: 114,
  TRADING: 115,
  PROFIT: 116,
  GIFT: 118,
  OTHER: 140
};

const GIFT_INHERITANCE_KEYS: string[] = [
  'source_of_wealth_id',
  'assets_from_full_name',
  'relationship_with_person',
  'assets_acquiring_way',
  'assets_receiving_year',
  'assets_value'
];

const PROFIT_KEYS: string[] = [
  'source_of_wealth_id',
  'name_sold_company',
  'sold_company_sell_value',
  'sold_company_sell_year',
  'sold_company_services',
  'sold_company_industry_id',
  'sold_company_subindustry_id',
  'sold_company_other_industry'
];

const OTHER_KEYS: string[] = ['source_of_wealth_id', 'assets_type', 'assets_from_full_name', 'assets_acquiring_way', 'assets_value'];

const DEFAULT_KEYS: string[] = ['source_of_wealth_id'];

export const FUND_SOURCES_KEYS: { [key: number]: string[] } = {
  [AOCH_SOURCE_OF_FUNDS_INYOVA_IDS.SALARY]: DEFAULT_KEYS,
  [AOCH_SOURCE_OF_FUNDS_INYOVA_IDS.INHERITANCE]: GIFT_INHERITANCE_KEYS,
  [AOCH_SOURCE_OF_FUNDS_INYOVA_IDS.TRADING]: DEFAULT_KEYS,
  [AOCH_SOURCE_OF_FUNDS_INYOVA_IDS.PROFIT]: PROFIT_KEYS,
  [AOCH_SOURCE_OF_FUNDS_INYOVA_IDS.GIFT]: GIFT_INHERITANCE_KEYS,
  [AOCH_SOURCE_OF_FUNDS_INYOVA_IDS.OTHER]: OTHER_KEYS
};

// https://www.amundietf.de/de/privatanleger/products/fixed-income/lyxor-green-bond-dr-ucits-etf-monthly-hedged-to-eur-acc/lu1563454823
export const BOND_LIST: Bond[] = [
  {
    id: 'id4',
    img: '/assets/images/bond-flags/germany.svg',
    perc: 19.89
  },
  {
    id: 'id3',
    img: '/assets/images/bond-flags/france.svg',
    perc: 14.77
  },
  {
    id: 'id9',
    img: '/assets/images/bond-flags/netherlands.svg',
    perc: 10.44
  },
  {
    id: 'id10',
    img: '/assets/images/bond-flags/other.svg',
    perc: 11.14
  },
  {
    id: 'id1',
    img: '/assets/images/bond-flags/usa.svg',
    perc: 4.67
  },
  {
    id: 'id6',
    img: '/assets/images/bond-flags/italy.svg',
    perc: 7.51
  },
  {
    id: 'id7',
    img: '/assets/images/bond-flags/spain.svg',
    perc: 4.63
  },
  {
    id: 'id8',
    img: '/assets/images/bond-flags/other.svg',
    perc: 26.95
  }
];

// https://www.ubs.com/ch/en/private/pension/pillar-3/maximal-contribution-2025.html
export const MAXIMUM_3A_CONTRIBUTION = {
  2024: {
    small: 7056,
    large: 35280,
    transfer_only: 0
  },
  2025: {
    small: 7258,
    large: 36288,
    transfer_only: 0
  },
  2026: {
    small: 7258,
    large: 36288,
    transfer_only: 0
  }
};

export const ESTIMATE_CONSTANTS_DE = {
  confidenceInterval: 1.44,
  stocksReturn: 0.0812,
  bondsReturn: 0.011,
  stocksVol: 0.1817,
  bondsVol: 0.043,
  correlation: 0.0203
};

export const ESTIMATE_CONSTANTS_CH = {
  confidenceInterval: 1.65,
  stocksReturn: 0.0787,
  bondsReturn: 0.011,
  stocksVol: 0.1651,
  bondsVol: 0.043,
  correlation: 0.0244
};

// https://www.eda.admin.ch/countries/united-kingdom/en/home/news/official-holidays.html
// MM/DD/YYYY
export const CH_LIST_OF_HOLIDAYS = [
  '12/25/2023',
  '12/26/2023',
  '12/31/2023',
  '01/01/2024',
  '01/02/2024',
  '03/29/2024',
  '04/01/2024',
  '05/06/2024',
  '05/09/2024',
  '05/20/2024',
  '05/27/2024',
  '08/01/2024',
  '08/26/2024',
  '12/24/2024',
  '12/25/2024',
  '12/26/2024',
  '12/31/2024'
];

// https://publicholidays.de/2024-dates/ - Nationals
// DD/MM/YYYY
export const DE_IDNOW_HOLIDAYS = [
  '01/01/2024',
  '29/05/2024',
  '01/04/2024',
  '01/05/2024',
  '09/05/2024',
  '20/05/2024',
  '03/10/2024',
  '25/12/2024',
  '26/12/2024'
];

export const DE_OTHER_HOLIDAYS = ['01/01/2024'];

export const BANK_HOLIDAYS = ['12/24/2022', '12/31/2022'];

export const RETIREMENT_AGE = 65;

export const AO_3A_PAGES = ['personal-details', 'contact-details', 'life-situation', 'summary', 'start-verification', 'finish-verification'];

export const NO_TIN_COUNTRY_LIST = ['BH', 'BM', 'VG', 'KY', 'OM', 'LK', 'QA', 'AE'];
export const TIN_COUNTRY_LIST = [
  'AT',
  'BE',
  'BG',
  'CY',
  'CZ',
  'DE',
  'DK',
  'EE',
  'ES',
  'FI',
  'FR',
  'GB',
  'GR',
  'HR',
  'HU',
  'IE',
  'IS',
  'IT',
  'LI',
  'LT',
  'LU',
  'LV',
  'MT',
  'NL',
  'NO',
  'PL',
  'PT',
  'RO',
  'SE',
  'SI',
  'SK'
];

export const APP_COUNTRIES = [
  { flag: 'ch', key: 'switzerland' },
  { flag: 'de', key: 'germany' }
];

// Commented is Lokalise translation
export const COMPANY_SECTOR_API_KEY = {
  Energy: 1, // Energy
  Materials: 2, // Raw materials
  Industrials: 3, // Industrials
  'Consumer Discretionary': 4, // Discretionary goods
  'Consumer Staples': 5, // Consumer staple goods
  'Health Care': 6, // Health care
  Financials: 7, // Financials
  'Information Technology': 8, // Information technology
  'Communication Services': 9, // Communication services
  Utilities: 10, // Utilities
  'Real Estate': 11 // Real estate
};

export const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export const AB_TESTS_LIST = {
  ibanInformation: 'iban_information',
  ibanReminder: 'iban_reminder'
};

export const REGISTER_PAGES = { en: 'create-profile', de: 'profil-erstellen', fr: 'creer-profil' };

export const MOBILE_APP = {
  nativeApp: 'https://app.inyova.ch/mobileapp',
  appStore: 'https://apps.apple.com/app/id1520194338',
  playStore: 'https://play.google.com/store/apps/details?id=mobile.app.yova'
};

export const DOCUMENT_TYPE_ID = {
  tax: 5,
  signed: 6,
  detailedreport: 8,
  intro: 11,
  accountdetails: 12,
  bankdetails: 14,
  amendment: 17,
  contract: 18,
  reports: 22,
  crowdinvesting: 42
};

export enum Documents3APagination {
  DEFAULT_RANGE = 10
}

export const INVESTMENT_CHIP_OPTIONS = {
  initial: {
    de: [2000, 5000, 10000, 50000],
    ch: [2000, 5000, 10000, 50000]
  },
  monthly: {
    de: [0, 100, 500, 1000, 2000],
    ch: [0, 100, 500, 1000, 2000]
  }
};

export const INVESTMENT_LIMITS = {
  monthly: {
    de: 500,
    ch: 500
  },
  initial: {
    de: 2000,
    ch: 2000
  },
  max: 99999999999999
};

export const INVESTMENT_LIMITS_3A = {
  initial: {
    ch: 100
  }
};
